import SparePartsFinderFiltersIndexTableRow from '../SparePartsFinderFiltersIndexTableRow';

export default class SPFFiltersCartIndexTableRow extends SparePartsFinderFiltersIndexTableRow {
    renderActions() {
        return <React.Fragment/>
    }

    createRowKey() {
        return `${super.createRowKey()}-modal`
    }

    createCheckboxId() {
        return `${super.createCheckboxId()}-modal`
    }

    renderActions() {
        return <React.Fragment/>
    }

    renderRowInternalActions() {
        return <React.Fragment/>
    }
}   